export default "__VITE_ASSET__fd02f694__"